import largerMoscow from '@/images/larger/1.jpg'
import largerPetersburg from '@/images/larger/2.jpg'
import largerBg from '@/images/bg/larger-bg.png'

const Records = () => {
  return (
    <section className="larger">
      <div className="container">
        <h2 className="section-title">
          Ещё больше рекордов
        </h2>

        <div className="larger-text">
          <p>
            Главными рекордсменами среди городов предсказуемо оказались
            Москва и Санкт-Петербург. Здесь не только самые высокие здания
            и самые населенные дома, но еще и рекорды, которые сложно
            измерить по всей стране, зато можно в рамках одного города.
          </p>

          <p>
            Самое старое жилое здание, самая короткая улица или улица без
            единого дома — и множество интересных фактов о них. Забирайте
            маршрут и отправляйтесь на рекордную прогулку вместе с 2ГИС.
          </p>
        </div>

        <div className="larger-row row">
          <div className="larger-block">
            <div className="larger-block-photo img-wrap">
              <img
                src={largerMoscow}
                alt="Рекорды Москвы"
                className="img-bg"
                loading="lazy"
              />

              <div className="larger-block__count">
                <span>12 мест</span>
              </div>

              <div className="larger-block__name">
                <span>Рекорды Москвы</span>
              </div>
            </div>

            <a
              href="https://2gis.ru/moscow/interesting/collection/2b3f9555-e7cb-4edf-be94-f0f5b6ebdcf1?m=37.62017%2C55.753466%2F11"
              className="larger-block__btn btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Перейти к подборке</span>
            </a>
          </div>

          <div className="larger-block">
            <div className="larger-block-photo img-wrap">
              <img
                src={largerPetersburg}
                alt="Рекорды Санкт-Петербурга"
                className="img-bg"
                loading="lazy"
              />

              <div className="larger-block__count">
                <span>12 мест</span>
              </div>

              <div className="larger-block__name">
                <span>Рекорды Санкт-Петербурга</span>
              </div>
            </div>

            <a
              href="https://2gis.ru/spb/interesting/collection/6cd3d58f-6137-4e78-bc10-13e965a263a3?m=30.314917%2C59.935891%2F16"
              className="larger-block__btn btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Перейти к подборке</span>
            </a>
          </div>
        </div>
      </div>

      <img
        src={largerBg}
        alt=""
        className="larger-bg"
        loading="lazy"
      />
    </section>
  )
}

export default Records